import { isAwaitingSubpublisherDistribution } from '~/modules/retailMedia/services/campaign/subpublisher-approval-status/poll'

interface GetDestinationUrlsStateParams {
  data: CampaignView
  isMultiBrand: boolean
  destinationCount?: number
}

// Everything the panel knows just by looking at the campaign: which journey
// it is in and which destination fields that journey reads. The panel and its
// body derive this from the same place instead of threading a dozen booleans
// through props.
export const getDestinationUrlsState = ({
  data,
  isMultiBrand,
  destinationCount = 0
}: GetDestinationUrlsStateParams) => {
  const isSubpublisherReview = !!data.isSubpublisherReview
  const isPendingReview = data.status === 'pending_review'
  const requireSubpublisherApproval =
    !!data.settings?.require_subpublisher_approval
  const showSubpublisherSections =
    !isSubpublisherReview && requireSubpublisherApproval

  const destinationUrl = isSubpublisherReview
    ? data.raw?.destination_urls?.[0]?.url
    : data.destinationUrl
  const destinationUrls = isSubpublisherReview
    ? data.raw?.destination_urls
    : data.destinationUrls

  const hasSingleDestinationDefined = !!destinationUrl
  const hasMultipleDestinationsDefined = !!destinationUrls?.length

  return {
    publisherId: data?.publisher?.id,
    isSubpublisherReview,
    isPendingReview,
    isRejectedSubpublisherReview:
      isSubpublisherReview && data.status === 'rejected',
    showSubpublisherSections,
    pendingReviewMode: isSubpublisherReview && isPendingReview,
    awaitingDistribution:
      showSubpublisherSections &&
      isAwaitingSubpublisherDistribution(data.status),
    destinationUrl,
    destinationUrls,
    // A catalog entry carries brand and publisher_id. The single-field handler
    // only emits { url }, so any configured destination on review uses the list.
    // A review with several saved URLs stays a list even with an empty catalog,
    // so none of them is dropped. With an empty catalog, single-brand keeps the single URL when it exists,
    // otherwise one empty field.
    isSingleDestination:
      !isMultiBrand &&
      !(
        isSubpublisherReview &&
        (destinationCount > 0 || (destinationUrls?.length ?? 0) > 1)
      ) &&
      (hasSingleDestinationDefined || !hasMultipleDestinationsDefined)
  }
}
